<label [for]="control.element.id" style="color: black; margin-bottom: 0">{{ label }} <span
  class="color-red">{{ control.isRequired() && control.element.readOnly !== true ? '*' : '' }}</span></label>
